// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"176":"projects","177":"home","597":"resume","631":"contact"}[chunkId] || chunkId) + "." + {"176":"d9c866d2","177":"476817ba","200":"a06fdf43","597":"545afea9","631":"0d555cd5"}[chunkId] + ".js";
};